import React from 'react';
import Menu from '../../components/globalComponents/headerMenu/menu';
import SocialIcons from '../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../components/globalComponents/footer/footer';

import './aboutUsPage.scss';
import AboutUs from '../../components/companyInfoComponents/aboutUs/aboutUs';
import TeamMember from '../../components/companyInfoComponents/teamMember/teamMember';
import ContactUs from '../../components/companyInfoComponents/contactUs/contactUs';
import HistoryCompany from '../../components/companyInfoComponents/historyCompany/historyCompany';
import Values from '../../components/companyInfoComponents/values/values';

const AboutUsPage = () => {
  return (
    <>
      <Menu />
      <AboutUs />
      <HistoryCompany />
      <TeamMember />
      <hr className="divider" />
      <Values />
      {/** <hr className="divider" />
            <ReviewCompany/> */}
      <ContactUs />
      <SocialIcons />
      <GradientLine />
      <Footer />
    </>
  );
};

export default AboutUsPage;
